import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('#root element is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Global crash reporting.
 *
 * Uncaught errors go straight into the bug-report intake, deduplicated
 * server-side by fingerprint. A support portal that cannot report its own
 * failures is the one place a silent error costs the most.
 */
window.addEventListener('error', (event) => {
  void reportBug(event.message, event.error?.stack);
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason as { message?: string; stack?: string } | undefined;
  void reportBug(reason?.message ?? String(event.reason), reason?.stack);
});

let lastReport = 0;

async function reportBug(message: string, stack?: string): Promise<void> {
  // An error inside a render loop can fire thousands of times a second; one
  // report a minute is plenty to diagnose it.
  if (Date.now() - lastReport < 60_000) return;
  lastReport = Date.now();

  await fetch('/api/bug-reports', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      subject: message.slice(0, 200),
      body: `Reported automatically from the web portal.\n\nURL: ${location.href}\nUser agent: ${navigator.userAgent}`,
      component: 'web-portal',
      severity: 'major',
      stack,
    }),
  }).catch(() => {
    /* the reporter must never itself throw */
  });
}
